import type {VariantSplit} from '@wix/document-services-types'
import _ from 'lodash'

export const forEachItemInVariantSplit = (variantSplit: VariantSplit, cb: Function) => {
    if (!variantSplit) {
        return
    }

    const {default: defaultValue, variants} = variantSplit

    if (defaultValue) {
        cb(defaultValue)
    }

    if (variants) {
        for (const {value} of variants) {
            cb(value)
        }
    }
}

export const VARIANTABLE_DATA_ITEM_KEYS = new Set(['default', 'variants'])

export const isVariantSplit = (value: unknown): value is VariantSplit => {
    return (
        _.isPlainObject(value) &&
        !_.isEmpty(value) &&
        Object.keys(value as Record<string, any>).every(key => VARIANTABLE_DATA_ITEM_KEYS.has(key))
    )
}
